import { render } from "./TermsLabo.vue?vue&type=template&id=01ca7b0d&ts=true"
import script from "./TermsLabo.vue?vue&type=script&lang=ts"
export * from "./TermsLabo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__